export default ({
  couponRepository,
  maps,
  auth
}) => {
  return async (payload) => {
    const {
      onSuccess,
      onError,
      data,
      actions,
      dispatch
    } = payload

    try {
      const coupon = await couponRepository.addCoupon({
        data,
        actions,
        maps,
        dispatch,
        auth: auth()
      })

      onSuccess({ coupon })
    } catch(e) {
      console.log(e)

      onError()
    }
  }
}
